import {App, ConfigProvider} from 'antd'
import React from 'react'

const getCSSVariable = (variable) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variable)
}
const isMobile = () => {
    return window.matchMedia('(max-width: 768px)').matches; // 768px là ngưỡng thông thường cho thiết bị mobile
};


const themeConfig = {
    // hashed: false,
    token: {
        colorPrimary: 'var(--color-primary)',
        colorLink: 'var(--color-primary)',
        // colorPrimary: getCSSVariable('--color-primary'), // Màu chính
        colorSecondary: getCSSVariable('--color-secondary'), // Màu phụ
        // colorLink: getCSSVariable('--link-color'), // Màu link
        colorTextBase: getCSSVariable('--text-color'), // Màu chữ chính
        colorText: getCSSVariable('--text-color'), // Màu chữ chính
        colorTextSecondary: getCSSVariable('--color-secondary'), // Màu chữ phụ
        colorTextPlaceholder: getCSSVariable('--color-text-placeholder'), // Màu chữ placeholder
        colorTextDisabled: getCSSVariable('--color-text-disabled'),
        colorTextHeading: getCSSVariable('--color-text-heading'),
        colorTextLabel: getCSSVariable('--color-text-label'),
        colorBorder: getCSSVariable('--border-color-base'), // Màu viền chính
        colorBorderSecondary: getCSSVariable('--border-color-secondary'), // Màu viền phụ
        activeBorderColor: getCSSVariable('--border-color-secondary'),
        colorBorderHover: getCSSVariable('--border-color-hover'),
        colorBorderDisabled: getCSSVariable('--border-color-disabled'), // Màu viền phụ
        colorPrimaryBg: getCSSVariable('--background'), // Màu nền chính
        colorBgBase: getCSSVariable('--background'), // Màu nền chính
        colorBgContainer: getCSSVariable('--background-container'), // Màu nền của các thẻ
        colorBgElevated: getCSSVariable('--background-elevated'), // Màu nền có độ nâng cao (box shadow)
        colorBgLayout: getCSSVariable('--background-layout'), // Màu nền layout chung
        colorBgSpotlight: getCSSVariable('--background-spotlight'), // Màu nền spotlight (highlight)
        colorError: getCSSVariable('--color-error'), // Màu lỗi
        colorBgMask: getCSSVariable('--background-mask'),
        controlHeight: isMobile() ? 36 : 32,

        defaultHoverColor: getCSSVariable('--text-color'),

        colorWarning: getCSSVariable('--color-warning'), // Màu cảnh báo
        colorSuccess: getCSSVariable('--color-success'), // Màu thành công
        colorInfo: getCSSVariable('--color-info'), // Màu thông tin

    },
    components: {
        Input: {
            activeBorderColor: '#009999',  // Màu của border Select hover
            hoverBorderColor: '#009999',  // Màu của border Select hover
        },
        Select: {
            colorPrimaryHover: '#009999', // Màu của border Select hover
            controlOutlineHover: '#009999',  // Màu của border Select hover
            controlOutline: '#009999',  // Màu của border Select hover
            hoverBorderColor: '#009999',  // Màu của border Select hover
        },
        Radio: {
            buttonSolidCheckedBg: getCSSVariable('--color-primary'), // Màu của Radio - Button
        },
        Breadcrumb: {
            separatorColor: getCSSVariable('--border-color-base'),
            itemColor: getCSSVariable('--border-color-base'),
        }
    },
}

const darkThemeConfig = {
    // hashed: false,
    token: {
        colorPrimary: "#26aaaa", // Màu chính
        colorSecondary: "#3399ff", // Màu phụ
        colorLink: "#66b3ff", // Màu link
        colorTextBase: "#e0e0e0", // Màu chữ chính
        colorText: "#e0e0e0", // Màu chữ chính
        colorTextSecondary: "#3399ff", // Màu chữ phụ
        colorTextPlaceholder: "#808080", // Màu chữ placeholder
        colorTextDisabled: "#5c5c5c", // Màu chữ bị vô hiệu hóa
        colorTextHeading: "#f5f5f5", // Chữ tiêu đề
        colorTextLabel: "#a5a5a5", // Nhãn ngắn, caption
        colorBorder: "#444444", // Màu viền chính
        colorBorderSecondary: "#555555", // Màu viền phụ
        colorBorderHover: "#666666", // Màu viền hover
        colorBorderDisabled: "#222222", // Màu viền bị vô hiệu hóa
        colorPrimaryBg: "#2a2a2a", // Màu nền chính
        colorBgBase: "#2a2a2a", // Màu nền chính
        colorBgContainer: "#1e1e1e", // Màu nền của các thẻ
        colorBgElevated: "#252525", // Màu nền có độ nâng cao (box shadow)
        colorBgLayout: "#181818", // Màu nền layout chung
        colorBgSpotlight: "#3a3a3a", // Màu nền spotlight (highlight)
        colorError: "#ff6b6b", // Màu lỗi
        colorBgMask: "#323232", // Màu nền mask (mờ)
        controlHeight: isMobile() ? 36 : 32, // Độ cao của control (button, input)
        colorWarning: "#ffcc00", // Màu cảnh báo
        colorSuccess: "#32cd32", // Màu thành công
        colorInfo: "#20adf8", // Màu thông tin
    },
    components: {
        Input: {
            activeBorderColor: '#009999', // Màu viền khi đang focus
            hoverBorderColor: '#009999',  // Màu viền khi hover
        },
        Select: {
            optionSelectedBg: '#2a2a2a',         // Màu nền của option được chọn
            optionActiveBg: '#252525',          // Màu nền khi hover option
            optionSelectedColor: '#66b3ff',     // Màu chữ của option đã chọn
            controlItemBgHover: '#2a2a2a',      // Màu nền của control khi hover
            colorPrimaryHover: '#009999',       // Màu primary khi hover (nút, border...)
            controlOutline: '#009999',          // Viền khi focus
        },
        Radio: {
            buttonSolidCheckedBg: '#26aaaa',     // Nền của Radio khi đã chọn (button style)
            buttonSolidCheckedColor: '#ffffff',  // Màu chữ khi Radio đã chọn
            colorPrimary: '#26aaaa',             // Màu chủ đạo cho radio (dot hoặc border)
        },
        Breadcrumb: {
            separatorColor: '#444444',           // Màu ký tự phân cách /
            itemColor: '#e0e0e0',                // Màu chữ của từng breadcrumb item
        },
    },
}


const AntdConfigProvider = ({children, ...props}) => {
    const bodyHasThemeDark = document.body.getAttribute('theme') === 'dark';
    return (
        <App>
            <ConfigProvider theme={{hashed: false, token: bodyHasThemeDark ? darkThemeConfig : themeConfig}} {...props}>
                {children}
            </ConfigProvider>
        </App>
    );
}

export default AntdConfigProvider
